import { ItemTrackingStatus, type RoadMapUpdate } from '@/domain/roadmap/types';

import { getEditableRoadmap } from './editableRoadmap';

export async function cloneRoadmapForCreate(idRoadmap: number): Promise<RoadMapUpdate> {
  const roadmap = await getEditableRoadmap(idRoadmap);
  return {
    ...roadmap,
    idRoadmap: 0,
    item: `${roadmap.item} - Clone`,
    type: roadmap.type
      ? {
          ...roadmap.type,
          roadmapStatus:
            roadmap.type.roadmapStatus?.map((s) => ({
              ...s,
              edited: true,
              roadmapStatusItems: s.roadmapStatusItems.map((i) => ({
                ...i,
                qualityAssurance: false,
                idRoadmapStatus: 0,
                status: ItemTrackingStatus.NotStarted,
              })),
            })) ?? null,
        }
      : null,
  };
}
